import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { convertQuoteToJob } from '../api/quotesApi';

// Wraps POST /ConvertToJob/{id} → { jobId }. Server flips the quote to
// Converted + ConvertedToJobId and creates the new Job in one transaction,
// then broadcasts UpdateQuoteTable / UpdateJobTable / UpdateQuoteDetail —
// the list/detail hooks own those subscriptions, so we do not invalidate
// here. Caller is expected to navigate to /jobs/{jobId} using the returned id.
export default function useConvertQuoteToJob() {
    return useMutation({
        // Caller passes `{ id, body }` — body carries JobNumber/StartDate/
        // EndDate/Site* from the Convert modal.
        mutationFn: ({ id, body }) => convertQuoteToJob(id, body),
        onSuccess: () => toast.success('Quote converted to job'),
        onError: (err) => toast.error(err?.message ?? 'Failed to convert quote'),
    });
}
